import CloseCardConfirm from './CloseCardConfirm';

export default CloseCardConfirm;
